import {
  CheckMetadata,
  ComparisonCheckType,
  createAttributeComparisonTableCheckMetadatas,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import { IdAttributeComparison } from 'dashboard/models/check';

export const computeIdAttributeComparisonMetadata = (
  check: IdAttributeComparison,
): CheckMetadata => {
  const metadata = check.metadata;
  // For now, we only support one item in comparison-input-results
  const comparisonResults = metadata?.['comparison-input-results']?.[0]?.['attribute-comparisons'];

  if (comparisonResults) {
    return {
      metadata: createAttributeComparisonTableCheckMetadatas(
        comparisonResults,
        ComparisonCheckType.IdAttributeComparison,
      ),
      hideIfVerificationPassed: false,
    };
  }

  return {
    metadata: [],
    hideIfVerificationPassed: false,
  };
};
